import React from "react";
import { RecallType } from "../../piping/RecallType";
import useRecall from "../../hooks/useRecall";

interface Props {
    text: string;
    type?: RecallType;
    ariaHidden?: boolean;
    render?(recalled: string): JSX.Element;
}

export function RecalledText(props: Props) {
    const { text, type, ariaHidden, render } = props;
    const recalled = useRecall(text, type);

    if (render) {
        return render(recalled);
    }
    if (ariaHidden !== undefined && ariaHidden !== null) {
        return <span aria-hidden={ariaHidden} dangerouslySetInnerHTML={{ __html: recalled }} />;
    }
    return <span dangerouslySetInnerHTML={{ __html: recalled }} />;
}
